import AuthPage from 'pages/AuthPage/AuthPage'

export default AuthPage
